var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.303 18.383C222.766 18.383 221.211 18.498 219.639 18.736C104.346 36.26 16 135.812 16 256S104.346 475.74 219.639 493.262C221.209 493.502 222.768 493.617 224.303 493.617C241.504 493.617 256 479.143 256 461.35V50.648C256 32.857 241.502 18.383 224.303 18.383ZM240 461.35C240 470.168 232.812 477.617 224.303 477.617C223.559 477.617 222.803 477.559 222.043 477.443C113.701 460.979 32 365.777 32 256C32 146.221 113.701 51.021 222.043 34.555C222.805 34.439 223.559 34.383 224.303 34.383C232.812 34.383 240 41.832 240 50.648V461.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHalf);
export default __webpack_public_path__ + "static/media/circle-half.2cf722dfd6ed2c91e832c58038790f71.svg";
export { ForwardRef as ReactComponent };